<template>
  <q-td :props="props" :key="colKey">{{ hSatzValues }}</q-td>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { trim } from "../../../utils";

export default defineComponent({
  props: {
    props: {
      type: Object,
      required: true,
    },
    colKey: {
      type: String,
      required: true,
    },
  },
  setup({ props }) {
    const hSatzValues = computed(() =>
      props.row.hsaetze && props.row.hsaetze.length
        ? trim(props.row.hsaetze.map((h: any) => h.satz).join(", "), 40)
        : "-"
    );

    return {
      hSatzValues,
    };
  },
});
</script>
